module.exports = __webpack_public_path__ + "static/seb-23c1491ddb382a62363f2cd1ac4159c5.png";